import React from 'react';
import {
  FlexDirectionEnum,
  Flex,
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { useTranslations } from '@unisporkal/localization';
import { useAsset } from '../../../hooks/stateful/useAsset';
import useOnLoad from '../../../hooks/queries/useOnLoad';
import PriceInfo from '../AssetSizes/PriceInfo/PriceInfo';
import styles from './VideoTemplate.module.scss';

const VideoTemplate = () => {
  const t = useTranslations();
  const {
    asset: { isVideoTemplate, videoTemplateApp, videoTemplateAppVersion },
  } = useAsset();

  const { response: { config: { options } = {} } = {} } = useOnLoad();

  if (!isVideoTemplate()) return null;

  const selectedOption = options?.length > 0 ? options[0] : null;

  if (!selectedOption?.sizes) return null;

  const size = selectedOption.sizes.find(
    (s) => s.name === 'zip-video-template'
  );

  if (!size) return null;

  const isEasyAccess = selectedOption.type === 'EasyAccess';

  const fileSize = `${size?.pixelWidth} x ${size?.pixelHeight} px | ${size?.fileSize}`;

  return (
    <>
      {isEasyAccess && (
        <Typography
          variant={TypographyVariant.body.small}
          className={styles.eza}
          component={TypographyComponentEnum.DIV}
        >
          {t('use_video_template_in_designs')}
        </Typography>
      )}
      <Flex
        flexDirection={FlexDirectionEnum.COLUMN}
        className={styles.card}
      >
        <Flex
          flexDirection={FlexDirectionEnum.ROW}
          className={styles.titleRow}
        >
          <Typography
            variant={TypographyVariant.body.medium}
            component={TypographyComponentEnum.SPAN}
            className={styles.title}
          >
            {t('video_template')}
          </Typography>
          <PriceInfo
            size={size}
            currencyCode={size.currencyCode}
          />
        </Flex>
        <Typography
          variant={TypographyVariant.body.xsmall}
          className={styles.row}
          component={TypographyComponentEnum.DIV}
        >
          {t('video_template_file', { app_name: videoTemplateApp?.text })}
        </Typography>
        <Typography
          variant={TypographyVariant.body.xsmall}
          component={TypographyComponentEnum.DIV}
          className={styles.size}
        >
          {fileSize}
        </Typography>
        <Typography
          variant={TypographyVariant.body.xsmall}
          component={TypographyComponentEnum.DIV}
        >
          {t('requires_version_or_newer', {
            version: videoTemplateAppVersion?.text,
          })}
        </Typography>
      </Flex>
    </>
  );
};

export default VideoTemplate;
